import React from "react";
import VariableForm from "./VariableForm";
import PageTitle from "@cs/components/src/PageTitle";
import ComponentForm from "./ComponentForm";
import PluginForm from "./PluginForm";
import PluginScriptNav from "./PluginScriptNav";
import { Route, Routes, useParams } from "react-router-dom";
// import { newPluginConfig, newScriptConfig } from './utils';
import { useQuery } from "react-query";
import Spinner from "@cs/components/src/Spinner";
import ApiService from "../../services/ApiService";
import { PageWrapperTwoColumn } from "@cs/components/src/PageWrapper";
import ScriptForm from "./ScriptForm";

const ConfigurePluginScriptEditScreen = () => {
  const { id, type } = useParams<{ id: string; type: string }>();
  // const navigate = useNavigate();

  const title = type === "plugin" ? "Plugin" : "Script";

  // const [dirty, setDirty] = useState(false);
  const { data, isLoading, isError } = useQuery({
    queryKey: ["config", type, id],
    queryFn: async () => {
      const response = await ApiService.fetch<{
        data: PluginConfigItem | ScriptConfigItem;
      }>("GET", `/api/config/${type}/${id}`);
      return response.data;
    },
    enabled: id !== "new", // && !dirty,
  });
  const config = data;
  const setConfig = () => {};
  // const [config, _setConfig] = useState(
  //   id === 'new' ? (type === 'plugin' ? newPluginConfig() : newScriptConfig()) : undefined,
  // );

  // const queryClient = useQueryClient();

  // const setConfig = (config: PluginConfigItem | ScriptConfigItem) => {
  //   setDirty(true);
  //   _setConfig(config);
  // };

  // Accept updates from the server until the user makes an edit
  // useEffect(() => {
  //   if (data) {
  //     _setConfig(data);
  //   }
  // }, [data]);

  // const saveMutation = useMutation({
  //   mutationFn: async () => {
  //     await ApiService.fetch('PUT', `/api/config/${type}/${config?.id}`, config);
  //     queryClient.invalidateQueries({ queryKey: ['configList', type] });
  //     queryClient.setQueryData(['config', id], config);
  //     setDirty(false);

  //     if (id === 'new') {
  //       navigate(`/config/${type}/${config?.id}`);
  //     }
  //   },
  // });

  // const deleteMutation = useMutation({
  //   mutationFn: async () => {
  //     await ApiService.fetch('DELETE', `/api/config/${type}/${config?.id}`);
  //     queryClient.invalidateQueries({ queryKey: ['configList', type] });
  //     navigate(`../${type}`);
  //     queryClient.invalidateQueries({ queryKey: ['config', type, id] });
  //   },
  // });

  return (
    <div>
      <PageTitle
        title={`View ${title} Definition`}
        previousTitle={`Configured ${title}s`}
        previousRoute={`../${type}`}
        // dirty={dirty}
        // success={saveMutation.isSuccess}
        error={
          isError
            ? `Problem loading ${type}`
            : // : saveMutation.isError
              // ? `Failed to save ${type}`
              // : deleteMutation.isError
              // ? `Failed to delete ${type}`
              undefined
        }
      >
        {/* <Button
          label="Delete"
          icon={Trash2}
          type="danger"
          borderless
          onClick={() => deleteMutation.mutate()}
          disabled={!config}
          loading={deleteMutation.isLoading}
        />
        <Button
          label="Save"
          icon={Save}
          type="success"
          onClick={() => saveMutation.mutate()}
          disabled={!config}
          loading={saveMutation.isLoading}
        /> */}
      </PageTitle>

      {isLoading ? (
        <Spinner />
      ) : isError ? (
        <></>
      ) : !config ? (
        <Spinner />
      ) : (
        <PageWrapperTwoColumn>
          <PluginScriptNav value={config} onChange={setConfig} />
          <Routes>
            {config.type === "iconik_plugin_config" && (
              <Route
                path="plugin"
                element={<PluginForm value={config} onChange={setConfig} />}
              />
            )}
            {config.type === "iconik_script_config" && (
              <Route
                path="script"
                element={<ScriptForm value={config} onChange={setConfig} />}
              />
            )}
            <Route
              path="variable/:componentId"
              element={<VariableForm value={config} onChange={setConfig} />}
            />
            {config.type === "iconik_plugin_config" && (
              <Route
                path="component/:componentId"
                element={<ComponentForm value={config} onChange={setConfig} />}
              />
            )}
          </Routes>
        </PageWrapperTwoColumn>
      )}
    </div>
  );
};

export default ConfigurePluginScriptEditScreen;
